import React, { Component } from 'react';
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
// core components
import Moment from 'react-moment';
import moment from 'moment';
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomTable from "components/TableLocker/TableLocker.js";
import DefaultLockerOptions from "../LockerOptions/DefaultLockerOptions";
import SocicamLockerOptions from "../LockerOptions/SocicamLockerOptions";
import IconButton from '@material-ui/core/IconButton';
import Arrow from "@material-ui/icons/ArrowBackIos";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import Circular from "components/Circular/Circular";
import Dropdown from "components/Dropdown/Dropdown";
import { getAllLockers } from "../../services/lockers/lockers";
import { getLockerRelated, getCondominioById } from "../../services/condominio/condominio";
import { getSlots } from '../../services/slots/slots';
import { createBrowserHistory } from "history";
import DashboardIcon from '@material-ui/icons/Dashboard';
import Tooltip from '@material-ui/core/Tooltip';
import RefreshIcon from '@material-ui/icons/Refresh';
import './lockerOperations.css';
import { getAllUsers, getMe } from "../../services/users/users";
import Confirm from "components/Orders/Confirm";
import Button from "components/CustomButtons/Button.js";
import SearchIcon from '@material-ui/icons/Search';
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from '@material-ui/core';
import FuseUtils from 'utils/FuseUtils';



Moment.globalMoment = moment;
Moment.globalLocale = 'pt-br';



const styles = theme => ({
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  iconView: {
    color: "gray !important"
  },
  iconViewArrow: {
    color: "white !important",
  },
  buttonIcon: {
    padding: "0.6rem 0.4rem 0.6rem 0.8rem",
    background: "#4caf50"
  },
  dropdown: {
    right: "1.5%",
    top: "12%",
    position: "absolute"
  }
});

class Lockers extends Component {
  constructor(props) {
    super(props);
    this.handleLoginClick = this.handleLoginClick.bind(this);
    this.handleLogoutClick = this.handleLogoutClick.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.getLockers = this.getLockers.bind(this);
    this.returnLockers = this.returnLockers.bind(this);
    this.setSelected = this.setSelected.bind(this);
    this.returnTemplate = this.returnTemplate.bind(this);
    this.getKeyByValue = this.getKeyByValue.bind(this);
    this.setGeoLocation = this.setGeoLocation.bind(this);
    this.createConfirm = this.createConfirm.bind(this);
    this.refreshLockers = this.refreshLockers.bind(this);
    this.setNotification = this.setNotification.bind(this);
    this.setDialog = this.setDialog.bind(this);
    this.createConfirmSync = this.createConfirmSync.bind(this);
    this.state = {
      isLoggedIn: false,
      showSlots: false,
      lockersData: [["Nenhum locker encontrado!"]],
      allLockersData: [["Nenhum locker encontrado!"]],
      currentLocker: null,
      lockerName: null,
      circular: true,
      options: ['Todos', 'Em operação', 'Em instalação', 'Em manutenção'],
      selected: 'Todos',
      statuses: { 'Todos': null, 'Em operação': ['active', 'Offline'], 'Online': 'active', 'Offline': 'inactive', 'Em instalação': 'installing', 'Em manutenção': 'maintenance' },
      statusColor: [],
      dateRefresh: new Date(),
      role: null,
      openDialog: false,
      lockerId: null,
      message: null,
      typeDialog: null,
      search: false,
      searchText: "",
      searchMode: "",
      searchStatus: ""
    };
  }

  onUnload(event) {
    createBrowserHistory({ forceRefresh: false }).push(`/`);

    const user = JSON.parse(localStorage.getItem('user'));
    // getAllUsers((users) => {
    //   let currentUser = users.filter(u => u.email === user.data.email)[0];
    //   if (currentUser && currentUser.roleName)
    //     this.setState({ role: currentUser.roleName });
    // });

    getMe((currentUser) => {
      if (currentUser && currentUser.roleName)
        this.setState({ role: currentUser.roleName });
    });
  }

  componentDidMount() {
    this.getLockers();
    /*window.onload = function () {
      this.onUnload();
    }.bind(this);*/
  }

  createConfirm(id, name) {
    this.setState({ openDialog: true, lockerId: id, lockerName: name, message: `Deseja deletar o Locker ${name}?`, typeDialog: 'delete' });
  }

  createConfirmSync(id, name) {
    this.setState({ 
      openDialog: true, 
      lockerId: id, 
      lockerName: name, 
      typeDialog: 'sync', 
      message: `Deseja enviar comando de SYNC para Locker ${name}?` 
    });
  }

  setDialog(openDialog) {
    this.setState({
      openDialog,
      showInfo: openDialog,
      showIntransit: openDialog,
      openCancel: openDialog,
      editOrder: openDialog,
    });
  }

  handleLoginClick() {
    this.setState({ isLoggedIn: true });
  }

  handleLogoutClick() {
    this.setState({ isLoggedIn: false });
  }

  getKeyByValue(object, value) {
    switch (value) {
      case 'active':
      case 'inactive':
        return ((<div className='locker-align-icons-text'><DashboardIcon style={{ color: '#00acc1' }} /><div>Em operação</div></div>));
      case 'installing':
        return ((<div className='locker-align-icons-text'><DashboardIcon style={{ color: '#858585' }} /><div>Em instalação</div></div>));
      default:
        return ((<div className='locker-align-icons-text'><DashboardIcon style={{ color: '#ffee00' }} /><div>Em manutenção</div></div>));
    }
  }

  setGeoLocation(geolocation) {
    localStorage.setItem("geo", JSON.stringify({ lat: geolocation.latitude, lng: geolocation.longitude }));

    createBrowserHistory({ forceRefresh: true }).push(`/geo`);
  }

  async refreshLockers() {
    this.setState({ circular: true, searchText: "", searchMode: null, searchStatus: null });
    this.getLockers();
  }

  async createLockerTable(data) {
    // let { lockersData } = this.state;
    // console.log(JSON.stringify(data))

    // let currStatus = this.state.statuses[this.state.selected];
    // let lockers = (Array.isArray(currStatus)) ? data.filter(d => d.status === 'active' || 'inactive') : (currStatus) ? data.filter(d => d.status === currStatus) : data;
    const lockers = data;

    this.setState({ lockersData: lockers, circular: false, dateRefresh: new Date() });

  }

  async getLockers() {

    getAllLockers((data) => {

      this.setState({ allLockersData: data });
      // console.log(JSON.stringify(data));
      this.createLockerTable(data);

    });
  }

  handleEdit(currentLocker, lockerName) {
    localStorage.setItem('lockerId', currentLocker);
    this.setState({ showSlots: true, currentLocker, lockerName })
  }

  returnLockers() {
    this.setState({ showSlots: false });
  }

  setSelected(selected) {
    this.setState({ selected, circular: true, lockersData: [["Nenhum locker encontrado!"]] }, () => this.componentDidMount());
  }

  returnTemplate(company) {

    switch (company) {
      case 'socicam':
        return (<SocicamLockerOptions lockerId={this.state.currentLocker} />);
      default:
        return (<DefaultLockerOptions lockerId={this.state.currentLocker} lockerName={this.state.lockerName} role={this.state.role} />);
    }
  }

  
  setNotification(message, success, type) {
    console.log('entrou aqui');
    this.setState(
      {
        circular: true,
        message,
        openDialog: true,
        typeDialog: type
      },
      () => this.loadPage()
    );
  }

  loadPage() {
    this.componentDidMount();

    // setTimeout(() => {
    //   this.handleClose();
    // }, 6000);
  }

  getCurrentUser() {
    const user = JSON.parse(localStorage.getItem('user'));

    // getAllUsers((users) => {
    //   let currentUser = users.filter(u => u.email === user.data.email)[0];

    //   if (currentUser && currentUser.roleName && this.state.role == null) {
    //     this.setState({ role: currentUser.roleName });
    //   }
    // });

    getMe((currentUser) => {
      if (currentUser && currentUser.roleName)
        this.setState({ role: currentUser.roleName });
    });
  }

  handleChange =  (event) => {
    const e = event.target.id ? event.target.id : event.target.name;
    const { value } = event.target;
    // console.log(JSON.stringify(this.state.allLockersData))
    console.log(e, value)
    var searchText = this.state.searchText;
    var searchStatus = this.state.searchStatus;
    var searchMode = this.state.searchMode;


    switch (e) {
      case 'searchText':
        // if (value) {
        //   await this.createLockerTable(this.state.allLockersData.filter((el) => ((el?.name?.toLowerCase().includes(value.toLowerCase())) || (el?.publicLockerId?.toLowerCase().includes(value.toLowerCase())) || (el?.cond?.toLowerCase().includes(value.toLowerCase())))));
        // } else {
        //   await this.createLockerTable(this.state.allLockersData);
        // }
        searchText = value;
        this.setState({searchText: value})
        break;
      case 'searchStatus':
        this.setState({searchStatus: value})
        const modeSearch = value; // (value)?value:'active';
        searchStatus = modeSearch;
        
        // if (value) {
        //   await this.createLockerTable(this.state.allLockersData.filter(d => ((modeSearch == 'active')?((d.mode == modeSearch) || (d.mode == "")):d.mode == modeSearch)));
        // } else {
        //   await this.createLockerTable(this.state.allLockersData);
        // }
        break;
      case 'searchMode':
        this.setState({searchMode: value})
        searchMode = value;
        // if (value) {
        //   await this.createLockerTable(this.state.allLockersData.filter(d => d.status == value));
        // } else {
        //   await this.createLockerTable(this.state.allLockersData);
        // }
        break;
    }

    var dataFiltered = this.state.allLockersData;

    if (searchText) {
      const valor = searchText;
      dataFiltered = FuseUtils.filterArrayByString(dataFiltered, valor); //await dataFiltered.filter((el) => ((el?.name?.toLowerCase().includes(valor.toLowerCase())) || (el?.publicLockerId?.toLowerCase().includes(valor.toLowerCase())) || (el?.cond?.toLowerCase().includes(valor.toLowerCase()))));
    }

    if (searchStatus) {
      const valor = searchStatus;
      const modeSearch = valor;
      dataFiltered = dataFiltered.filter(d => (((modeSearch != 'active') && (modeSearch != ''))?d.mode == modeSearch:((d.mode == modeSearch) || (d.mode == "") || (!d.mode))));
    }

    if (searchMode) {
      const valor = searchMode;
      dataFiltered = dataFiltered.filter(d => d.status == valor);
    }


    this.createLockerTable(dataFiltered);
    
  };

  render() {
    // setTimeout("location.reload();",60000);

    this.getCurrentUser();
    const { classes } = this.props;
    const { search, searchText, searchStatus, searchMode } = this.state;
    const { showSlots, circular, selected } = this.state;

    let layout;

    if (!showSlots) {
      layout = <Card>
        <CardHeader color="primary">
          <h4 className={classes.cardTitleWhite}>Lockers</h4>
          <p className={classes.cardCategoryWhite}> </p>
          {/* <Dropdown
            className={classes.dropdown}
            options={this.state.options}
            selected={this.state.selected}
            setSelected={this.setSelected}
          /> */}
        </CardHeader>
        <div style={{ justifyContent: "right", marginLeft: 20, marginRight: 20, marginTop: 12}}>
        <GridContainer>
              <GridItem xs={6} sm={6} md={3} >
                <TextField
                  label="Condomínio ou Locker"
                  id="searchText"
                  name="searchText"
                  value={searchText}
                  onChange={this.handleChange}
                  fullWidth
                >
                </TextField>
              </GridItem>
              <GridItem xs={6} sm={6} md={3} >
                <TextField
                  className={classes.green
                  }
                  select
                  label="Status do Terminal"
                  name="searchStatus"
                  id="searchStatus"
                  value={searchStatus}
                  onChange={this.handleChange}
                  fullWidth
                >
                  <MenuItem value="active" key="1d">
                    Em operação
                  </MenuItem>
                  <MenuItem value="inactive" key="4d">
                    Inativo
                  </MenuItem>
                  <MenuItem value="installing" key="2d">
                    Em ativação
                  </MenuItem>
                  <MenuItem value="maintenance" key="3d">
                    Em manutenção
                  </MenuItem>
                  <MenuItem value="" key="1wd" selected>
                    -
                  </MenuItem>
                </TextField>
              </GridItem>
              <GridItem xs={6} sm={6} md={3} >
                <TextField
                  className={classes.green
                  }
                  select
                  label="Status"
                  name="searchMode"
                  id="searchMode"
                  value={searchMode}
                  onChange={this.handleChange}
                  fullWidth
                >
                  <MenuItem value="active" key="1d">
                    Online
                  </MenuItem>
                  <MenuItem value="inactive" key="2d">
                    Offline
                  </MenuItem>
                  <MenuItem value="" key="2dd">
                    -
                  </MenuItem>
                </TextField>
              </GridItem>
              <Grid xs={6} sm={6} md={3} style={{flex: 1, justifyContent: "center", textAlign: "right", textJustify: "auto" , alignItems: "center"}} fullWidth>
                  Atualizado em <Moment format="HH:mm">{this.dateRefresh}</Moment>
                  <IconButton onClick={() => this.refreshLockers()}>
                    <RefreshIcon />
                  </IconButton>
            </Grid>
            </GridContainer>
          {/* <GridContainer>
            <GridItem xs={8} sm={8} md={8} >
              <Button color="primary" onClick={() => this.setState({ search: !this.state.search })} ><SearchIcon /><span>{(!this.state.search) ? "Mostrar" : "Esconder"} Pesquisa</span></Button>
            </GridItem>
            <GridItem xs={4} sm={4} md={4} justifyContent="flex-end">
              Atualizado em <Moment format="DD/MM/YYYY HH:mm">{this.dateRefresh}</Moment>
              <IconButton onClick={() => this.refreshLockers()}>
                <RefreshIcon />
              </IconButton>
            </GridItem>
          </GridContainer> */}
        </div>
        <div style={{ marginLeft: 20, marginRight: 20, justifyContent: "right" }}>
          {search &&
            <GridContainer>
              <GridItem xs={12} sm={12} md={6} >
                <TextField
                  label="Condomínio ou Locker"
                  id="searchText"
                  name="searchText"
                  value={searchText}
                  onChange={this.handleChange}
                  fullWidth
                >
                </TextField>
              </GridItem>
              <GridItem xs={6} sm={6} md={3} >
                <TextField
                  className={classes.green
                  }
                  select
                  label="Status do Terminal"
                  name="searchStatus"
                  id="searchStatus"
                  value={searchStatus}
                  onChange={this.handleChange}
                  fullWidth
                >
                  <MenuItem value="active" key="1d">
                    Em operação
                  </MenuItem>
                  <MenuItem value="inactive" key="4d">
                    Inativo
                  </MenuItem>
                  <MenuItem value="installing" key="2d">
                    Em ativação
                  </MenuItem>
                  <MenuItem value="maintenance" key="3d">
                    Em manutenção
                  </MenuItem>
                  <MenuItem value="" key="1wd" selected>
                    -
                  </MenuItem>
                </TextField>
              </GridItem>
              <GridItem xs={6} sm={6} md={3} >
                <TextField
                  className={classes.green
                  }
                  select
                  label="Status"
                  name="searchMode"
                  id="searchMode"
                  value={searchMode}
                  onChange={this.handleChange}
                  fullWidth
                >
                  <MenuItem value="active" key="1d">
                    Online
                  </MenuItem>
                  <MenuItem value="inactive" key="2d">
                    Offline
                  </MenuItem>
                  <MenuItem value="" key="2dd">
                    -
                  </MenuItem>
                </TextField>
              </GridItem>
            </GridContainer>}
        </div>
        <CardBody>
          {(circular) ? <Circular /> : <CustomTable
            tableHeaderColor="primary"
            tableHead={["Locker", "Condomínio", "Status do Terminal", "WhatsApp", "Status", "Ocupação", "Ação"]}
            tableData={this.state.lockersData}
            handleEdit={this.handleEdit}
            setGeoLocation={this.setGeoLocation}
            createConfirmSync={this.createConfirmSync}
            createConfirm={this.createConfirm}
            stylesLockers={styles}
            role={this.state.role}
            iconView={this.props.classes.iconView}
          />}
        </CardBody>
      </Card>;
    } else {
      layout = this.returnTemplate(localStorage.getItem('company'));
    }

    return (
      <div>
        <GridContainer>
          {(showSlots) ? <Tooltip title="Voltar"><IconButton className={classes.buttonIcon} onClick={() => this.returnLockers()} aria-label="view"><Arrow className={classes.iconViewArrow} /></IconButton></Tooltip> : null}
          <GridItem xs={12} sm={12} md={12}>
            {layout}
          </GridItem>
        </GridContainer>

        {this.state.openDialog ? (
          <Confirm
            lockerId={this.state.lockerId}
            lockerName={this.state.lockerName}
            open={this.state.openDialog}
            message={this.state.message}
            type={this.state.typeDialog}
            setNotification={this.setNotification}
            onChange={this.setDialog}
          />
        ) : null}
      </div>
    );
  }
}
export default withStyles(styles)(Lockers);